module.exports = __webpack_public_path__ + "img/jianjietopmin.6e5cdce3.jpg";